goog.provide("shadow.js.shim.module$$mui$material$ListSubheader");
goog.provide("module$shadow_js_shim_module$$mui$material$ListSubheader");
shadow.js.shim.module$$mui$material$ListSubheader = shadow.js.nativeProvides["@mui/material/ListSubheader"] = shadow$bridge("@mui/material/ListSubheader");
module$shadow_js_shim_module$$mui$material$ListSubheader.default = shadow.js.shim.module$$mui$material$ListSubheader;
